var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMuteShadow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18064_219976)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18064_219976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9387 1.76683C12.7304 1.66853 12.2302 1.60205 12.034 1.76687L6.48053 6.44602H3.69751C3.03768 6.44602 2.5 6.97777 2.5 7.63032V12.3675C2.5 13.0213 3.03768 13.5518 3.69751 13.5518H6.48053L12.034 18.289C12.143 18.3743 12.6754 18.3102 12.6754 18.3102C12.6754 18.3102 12.8561 18.2689 12.9387 18.2298C13.1459 18.1315 13.2776 17.9243 13.2776 17.6969V2.30095C13.2776 2.07357 13.1459 1.86631 12.9387 1.76683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9194 5.81126C15.6861 5.58151 15.3119 5.58506 15.0821 5.816C14.8524 6.04931 14.8548 6.42355 15.0869 6.65449C15.9822 7.53798 16.4749 8.72584 16.4749 9.99897C16.4749 11.2721 15.9822 12.46 15.0869 13.3434C14.8548 13.572 14.8524 13.9474 15.0821 14.1807C15.1982 14.298 15.351 14.356 15.5026 14.356C15.653 14.356 15.8034 14.2992 15.9194 14.1843C17.0422 13.0793 17.6592 11.5919 17.6592 9.99897C17.6592 8.40608 17.0422 6.91859 15.9194 5.81126Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18064_219976",
    x: 1.5,
    y: 1.66666,
    width: 17.1602,
    height: 18.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18064_219976"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18064_219976",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18064_219976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMuteShadow);
export default __webpack_public_path__ + "static/media/icon-mute-shadow.ba4a9c18ee242a3fbc18db72677767c5.svg";
export { ForwardRef as ReactComponent };